export enum CostMutations {
  RESET = "RESET",
  SET_COST = "SET_COST",
  SET_COSTS = "SET_COSTS",
  ADD = "ADD",
  SET_ECONOMY_DEFAULT_OPTIONS = "SET_ECONOMY_DEFAULT_OPTIONS",
}
